import { PageHeader } from '@verantos-dev/shared-components';

import { CopyCohortModal } from '../../components/CopyCohortModal/CopyCohortModal';
import { useCohortsListPageHeader } from '../../hooks/useCohortsListPageHeader';
import { CreateCohortModal } from '../CreateCohortModal/CreateCohortModal';
import { DeleteCohortModal } from '../DeleteCohortModal/DeleteCohortModal';
import { ExportCohortModal } from '../ExportCohortModal/ExportCohortModal';
import { RenameCohortModal } from '../RenameCohortModal/RenameCohortModal';

export const CohortsListPageHeader = () => {
  const {
    actions,
    breadcrumbs,
    pageTitle,
    isCreateCohortModalOpen,
    isDeleteCohortModalOpen,
    isRenameCohortModalOpen,
    isExportCohortModalOpen,
    isCopyCohortModalOpen,
  } = useCohortsListPageHeader();

  return (
    <>
      <PageHeader
        id="cohortsListPageHeader"
        pageTitle={pageTitle}
        actions={actions}
        breadcrumbs={breadcrumbs}
      />
      {isCreateCohortModalOpen && <CreateCohortModal />}
      {isDeleteCohortModalOpen && <DeleteCohortModal />}
      {isRenameCohortModalOpen && <RenameCohortModal />}
      {isExportCohortModalOpen && <ExportCohortModal />}
      {isCopyCohortModalOpen && <CopyCohortModal />}
    </>
  );
};
